export const FIELD_FIELDS = `
  fragment fieldFields on Field {
    _id
    name
    photo
    location {
      address
      coordinates
      type
    }
  }
`;

export const GET_FIELDS = `
${FIELD_FIELDS}
query ($term: String, $fieldIds: [String], $skip: Int, $limit: Int) {
  getFields(term: $term, fieldIds: $fieldIds, skip: $skip, limit: $limit) {
    ...fieldFields
  }
}`;

export const CREATE_FIELD = `
  mutation ($field: FieldInput) {
    createField(field: $field) {
      _id
    }
  }
`;

export const EDIT_FIELD = `
${FIELD_FIELDS}
  mutation ($fieldId: String!, $field: FieldInput) {
    editField(fieldId: $fieldId, field: $field) {
        ...fieldFields
    }
  }
`;

export const DELETE_FIELD = `
  mutation ($fieldId: String!) {
    deleteField(fieldId: $fieldId)
  }
`;
